'use strict';
const querystring = require('querystring');

const UriUtil = {
    // convert a query string or url fragment to an object
    // decodePlus will treat '+' signs as spaces (an incorrect usage, but one which exists)
    queryStringToObject(string, decodePlus=false) {
        if (!string) return {};

        let preparsed = string;
        if (decodePlus) preparsed = string.replace(/\+/g, '%20');
        preparsed = decodeURIComponent(preparsed);

        if (
            preparsed.length > 0
            && (
                preparsed[0] === '?'
                || preparsed[0] === '#'
            )
        ) {
            preparsed = preparsed.substr(1);
        }

        return preparsed.split("&")
            .map(v => v.split("="))
            .reduce((pre, [key, value]) => ({ ...pre, [key]: value }), {} );
    },

    // alternate method using node querystring module
    getQueryStringObject() {
        const unparsedQueryString = window.location.search || '';
        let formattedUnparsedQueryString = unparsedQueryString;
        if (unparsedQueryString[0] === '?') {
            formattedUnparsedQueryString = unparsedQueryString.substr(1);
        }

        return querystring.parse(formattedUnparsedQueryString);
    },

    parseLocationSearchString(location) {
        if (!location || !location.search) {
            return {};
        }

        const unparsedQueryString = location.search || '';
        let formattedUnparsedQueryString = unparsedQueryString;
        if (unparsedQueryString[0] === '?') {
            formattedUnparsedQueryString = unparsedQueryString.substr(1);
        }

        return querystring.parse(formattedUnparsedQueryString);
    },

    createQueryStringFromObj(queryStringObj, addLeadingQuestionMark=false) {
        const qs = querystring.stringify(queryStringObj);
        if (!addLeadingQuestionMark) {
            return qs;
        }
        else {
            return `?${qs}`;
        }
    },

    addObjToExistingQueryString(location, queryStringObj, addLeadingQuestionMark=false) {
        const existingQueryObj = this.parseLocationSearchString(location);
        const updatedQsObj = { ...existingQueryObj, ...queryStringObj };
        return this.createQueryStringFromObj(updatedQsObj, addLeadingQuestionMark);
    },

    getFullPathFromLocation(location) {
        if (typeof location !== 'object') return '';

        if (!!location.search) {
            return location.pathname + location.search;
        }

        return location.pathname;
    }
}

module.exports = UriUtil;